<template>
  <v-main
    v-bind:style="isMobileMode && isSubMenuVisible && !hideSubMenu && isFirstClick? 'margin-left: 256px': ''"
  >

    <router-view id="content" />
    <dashboard-core-footer />
  </v-main>
</template>
 
<script>
import { mapState, mapGetters, mapMutations } from "vuex";
export default {
  name: "DashboardCoreView",

  components: {
    DashboardCoreFooter: () => import("./Footer")
  },

  created() {
      window.addEventListener('beforeunload', this.resett())
      window.addEventListener("resize", this.resett());
  },

  beforeDestroy() {
    if (typeof window !== "undefined") { 
      window.removeEventListener('beforeunload', this.resett())
      window.removeEventListener("resize", this.resett());
    }
  },

  methods: {
    resett(){
      this.$store.commit("SET_MAIN_MENUCLICK", false); 
    }
  },

  computed: {
    ...mapState([
      "isMobileMode",
      "isSubMenuVisible",
      "isFirstClick",
      "hideSubMenu"
    ]), 
  }
};
</script>
